// extracted by mini-css-extract-plugin
module.exports = {"form-layout":"authModal_form-layout___0jCJ","ltr-input":"authModal_ltr-input__je9u1","input-phone":"authModal_input-phone__c5adY","actions":"authModal_actions___dRC0"};